import React, { useMemo } from "react";
import { Box, Typography } from "@mui/material";
import { openCallPopupWindow } from "../../../utils/openCallPopupWindow";

function resolveRequestId(protocol, leadId) {
  const fromProtocol = Number(protocol);
  if (Number.isFinite(fromProtocol) && fromProtocol > 0) return fromProtocol;
  const fromLead = leadId != null ? Number(leadId) : NaN;
  if (Number.isFinite(fromLead) && fromLead > 0) return fromLead;
  return null;
}

function resolveTaskLinkMode(content, cardId) {
  const fromProp = cardId != null ? Number(cardId) : NaN;
  if (Number.isFinite(fromProp) && fromProp > 0) return true;
  return /tarefa\s*#\d+/i.test(String(content || ""));
}

const TeamSystemMessageText = ({ content, leadId, cardId = null, onOpenTask = null }) => {
  const nodes = useMemo(() => {
    const text = String(content || "");
    if (!text) return null;

    const asTask = resolveTaskLinkMode(text, cardId);
    const parts = [];
    let lastIndex = 0;
    const re = /#(\d+)/g;
    let match = re.exec(text);

    while (match) {
      if (match.index > lastIndex) {
        parts.push(text.slice(lastIndex, match.index));
      }

      const protocol = match[1];
      const entityId = asTask
        ? Number(protocol)
        : resolveRequestId(protocol, leadId);
      const canOpen =
        entityId != null &&
        Number.isFinite(Number(entityId)) &&
        Number(entityId) > 0 &&
        (!asTask || typeof onOpenTask === "function");

      parts.push(
        <Typography
          key={`protocol-${match.index}-${protocol}`}
          component="span"
          role="link"
          tabIndex={0}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (!canOpen) return;
            if (asTask) {
              onOpenTask(Number(entityId));
              return;
            }
            openCallPopupWindow(entityId);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              e.stopPropagation();
              if (!canOpen) return;
              if (asTask) {
                onOpenTask(Number(entityId));
                return;
              }
              openCallPopupWindow(entityId);
            }
          }}
          sx={{
            color: "primary.main",
            fontWeight: 600,
            cursor: canOpen ? "pointer" : "default",
            textDecoration: "underline",
            textUnderlineOffset: "2px",
            "&:hover": { color: "primary.dark" },
          }}
        >
          #{protocol}
        </Typography>
      );

      lastIndex = re.lastIndex;
      match = re.exec(text);
    }

    if (!parts.length) return text;
    if (lastIndex < text.length) parts.push(text.slice(lastIndex));
    return parts;
  }, [content, leadId, cardId, onOpenTask]);

  return (
    <Box
      component="span"
      sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
    >
      {nodes}
    </Box>
  );
};

export default TeamSystemMessageText;
